import { RuleSet } from '@app/shared/condition-builder';

export interface ICenterRaw {
  skuCentro: string;
  descCentro: string;
  descLCentro: string;
}

export interface IServiceRaw {
  skuServicio: string;
  descServicio: string;
  descLServicio: string;
}

export interface IAreaRaw {
  skuAreas: string;
  descAreas: string;
  descLAreas: string;
}

export interface IAntibioticoRaw {
  codAntibiotico: string;
  descAntibiotico: string;
  descLAntibiotico: string;
}

export interface ILabRaw {
  skuLaboratorio: string;
  descLaboratorio: string;
  descLLaboratorio: string;
}


export interface ISensibilidadRaw {
  descLSensibilidad: string;
}

export interface IDianosisRaw {
  skuDiagnostico: string;
  descDiagnostico: string;
  descLDiagnostico: string;
}

export interface ITargetRaw {
  skuDestino: string;
  descDestino: string;
  descLDestino: string;
}

export interface ITipoPeticionRaw {
  skuTipoPeticion: string;
  codTipoPeticion: string;
  descTipoPeticion: string;
  descLTipoPeticion: string;
}

export interface IOption {
  id: string;
  description: string;
}

export interface IClinicalTrialQuery {
  centerId?: string;
}

export interface ICreateExportOptions {
  centerId: string;
  serviceId: string;
  targetId: string;
  diagnosisId: string;
  areaId: string;
  labId: string;
  tipoPeticionId: string;
  registerRange: Date[];
  ageFrom: number;
  ageTo: number;
  validationRange: Date[];
  validationRangeEpisode?: Date[];
  gender: string;
  reasonRequest: string;
  urgent: string;
  queryBuilder: RuleSet;
  comment: string;
  priority?: string;
  episode?: string;
  target?: string;
  externalSystem?: string;
  notesHCIS?: string;
  externalDate?: string;
  info9?: string;
  hcisUnity?: string;
  extractor?: string;
  appointments?: string;
  appointmentDates?: string;
  methods?: number[];
  strictMethodMatch?: boolean;
  numPeticion?: string[];
  codPatient?: string[];
  fields?: string[];
  includeHistoricalData?: boolean;
  historicDatabaseName?: string;
  demographicDataOnly?: boolean;
}

export interface IQueryBuilderConfig {
  historicDatabaseName: string;
}

/** Métodos distintos devueltos por pivot-methods (#575) */
export interface PivotMethod {
  skuMetodo: number;
  descLMetodo?: string | null;
  metodoOrden?: number | null;
  hasSecondary: boolean;
}

export interface Determinacion {
  skuLaboratorio: number;
  numPeticion: string;
  codpeticion: string;
  fechaPeticionDt: string;
  fechaEmisionDt: string;
  fechaCita: string;
  descLMicroorganismo?: string;
  fechaExtraccion: string;
  fechaRegistro: string;
  fechaRecepcion: string;
  motivoSolicitud: string;
  urgente: string;
  info_1: string;
  info_2: string;
  info_3: string;
  info_4: string;
  info4Dt: string;
  info_5: string;
  info_6: string;
  info_7: string;
  info_8: string;
  info_9: string;
  info_10: string;
  attrib1: string;
  attrib2: string;
  attrib3: string;
  attrib4: string;
  attrib5: string;
  mikroattrib2: string;
  mikroattrib3: string;
  mikroattrib4: string;
  mikroattrib5: string;
  adicional1informes: string;
  adicional2informes: string;
  fechaMetodoDt: string;
  fechaResultado: string;
  fechaValidacionDt: string;
  fechaImpresion: string;
  resultado: string;
  tipoRegistro: string;
  facturable: string;
  determinacionesUrgente: string;
  rescuanti: string;
  patologia: string;
  determinacionesAdicional1: string;
  determinacionesAdicional2: string;
  idAreavalidacion: number;
  skuAnalizador: number;
  skuMetodo: number;
  skuAreas: number;
  resultado2: string;
  rescuanti2: string;
  skuPaciente: number;
  nomPaciente: string;
  apellidos: string;
  fechaNac: string;
  edad?: number;
  sexo: string;
  pacienteCod_1: string;
  pacienteCod_2: string;
  pacienteCod_3: string;
  domicilio: string;
  codigoPostal: string;
  ciudad: string;
  pais: string;
  paisOrigen: string;
  raza: string;
  skuServicio: number;
  nombreServicio: string;
  skuDiagnostico: number;
  codDiagnostico: string;
  descDiagnostico: string;
}
